import { UserRole, RoleTypes } from 'firebaseFunctions/types'

export const mockUserRoleB: UserRole = {
  email: 'mockUserB@mailinator.com',
  displayName: 'Bruce Wayne',
  role: RoleTypes.Owner,
  photoURL: 'https://lh3.googleusercontent.com/-8GlWPXK3a3M/AAAAAAAAAAI/AAAAAAAAAAA/ACHi3rdOaEksVzZdY2WYvkojCNy6CCj8Hg.CMID/s64-c/photo.jpg',
}
